import Api from "../apiService";

class templatesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/templates`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/templates/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, templateData) {
    return Api.postRequest(
      `companies/${companyId}/templates`,
      templateData,
      Api.authHeaders()
    );
  }

  update(companyId, id, templateData) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${id}`,
      templateData,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  renderPdf(companyId, id, params) {
    return Api.getRequest(
      `companies/${companyId}/templates/${id}/render_pdf.pdf`,
      params,
      Api.authHeaders(),
      { responseType: "blob" } // важно для получения файла
    );
  }

  duplicate(companyId, id, params) {
    return Api.postRequest(
      `companies/${companyId}/templates/${id}/duplicate`,
      params,
      Api.authHeaders()
    );
  }
}

export default new templatesApi();
